/**
 * OmniInvokeService — Thin re-export wrapper for the bridge invoke utility.
 * Exists to satisfy dynamic import paths used in SettingsBindingService.
 */
export { omniInvoke } from '@/utils/bridge';
